const { CHANGE_ITEM } = require("../constants")

const initialState = {
  activeItem: ""
}

const reducer = (state = initialState, action) => {
  switch(action.type){
    case CHANGE_ITEM:
      return {
        ...state,
        activeItem: action.payload
      }
  }
}

export default reducer